import {getPlayers} from "modules/selectors/players";
import {getUnits} from "modules/selectors/units";

/**
 * Make players object with next available match and lineup
 * @param player
 * @param nextMatch
 */
export const buildPlayerObject = (
	player: ReturnType<typeof getPlayers>[number],
	nextMatch?: ReturnType<typeof getUnits>[number]
) => {
	const lineup = nextMatch?.lineups.find((it) => it.playerId === player.id);

	return {
		...player,
		nextMatch,
		lineup: lineup,
	};
};

/**
 * Formats stats to 3 digits after coma
 */

export const toFixedStats = (value?: number | null) => {
	if (value === null) {
		return "-";
	}
	if (!value) {
		return `.000`;
	}
	if (value === 1) {
		return `1.000`;
	}
	if (value > 1) {
		return value.toFixed(3);
	} else {
		return value.toFixed(3).substring(1);
	}
};

export const toFixedNumber = (value?: number | null) => {
	if (value === null) {
		return "-";
	}
	if (!value) {
		return 0;
	}
	return +value.toFixed(2);
};

export const toNumberFormat = (value?: number | null) => {
	if (value === null) {
		return "-";
	}
	if (!value) {
		return "0";
	}
	return value.toLocaleString("en-us");
};

export const buildPlayerFullName = (
	player?: ReturnType<typeof getPlayers>[number],
	placeholder: string = "-"
) => {
	if (!player) {
		return placeholder;
	}

	if (player.firstName) {
		return `${player.firstName[0]}. ${player.lastName}`;
	}

	return player.lastName || placeholder;
};
